<template>
  <div class="container">
    <div class="title"><h1>Career</h1></div>
    <div class="slideholder" id="careerslider">
      <div class="slide" id="ppi">
        <img class="bigimage" src="../assets/nats.png" />
        <div class="card">
          <div class="logoholder">
            <img class="logo" src="../assets/pproducts.png" />
            <h2 class="company">Professional Products</h2>
            <h2 class="jobtitle">
              System Design Engineer <br />Software Development Team
            </h2>
            <h3 class="years">2005 - 2011</h3>
          </div>
          <p class="textblock">
            I began at PPI as an Assistant Engineer, and was quicly promoted to
            System Design Engineer. While there, I architected and built
            training and multimedia systems ranging from simulation centers at
            medical schools to the scoreboard control room for the Washington
            Nationals.
          </p>
          <Arrow direction="right" @scroll="slide('cei')" />
        </div>
      </div>
      <div class="slide" id="cei">
        <img class="bigimage" src="../assets/jhsph.jpg" />
        <div class="card">
          <div class="logoholder">
            <img class="logo" src="../assets/cei.png" />
            <h2 class="company">Communications Engineering</h2>
            <h2 class="jobtitle">Senior Systems Engineer</h2>
            <h3 class="years">2011 - 2012</h3>
          </div>
          <p class="textblock">
            CEI is a systems integrator specializing in broadcast and production
            workflows. As Senior Systems Engineer I designed systems for the
            Discovery Channel, the US State Department, and the Smithsonian Air
            &amp; Space Museum.
          </p>
          <Arrow direction="left" @scroll="slide('ppi')" />
          <Arrow direction="right" @scroll="slide('eplus')" />
        </div>
      </div>
      <div class="slide" id="eplus">
        <img class="bigimage" src="../assets/skgf.jpg" />

        <div class="card">
          <div class="logoholder">
            <img class="logo" src="../assets/eplus.png" />
            <h2 class="company">ePlus Technology</h2>
            <h2 class="jobtitle">Consultant<br /></h2>
            <h3 class="years">2012 - 2014</h3>
          </div>
          <p class="textblock">
            ePlus provides IT products and services to enterprise companies. As
            a consultant, I designed and commissioned collaboration and
            communication systems that integrated a variety of tools from
            different vendors into cohesive work environments.
          </p>
          <Arrow direction="left" @scroll="slide('cei')" />
          <Arrow direction="right" @scroll="slide('oblong')" />
        </div>
      </div>
      <div class="slide" id="oblong">
        <img class="bigimage" src="../assets/oblong-bg.png" />
        <div class="card">
          <div class="logoholder">
            <img class="logo" src="../assets/oblong.png" />
            <h2 class="company">Oblong Industries</h2>
            <h2 class="jobtitle">
              Lead Solutions Architect &amp; <br />
              Sales Engineering Manager
            </h2>
            <h3 class="years">2014 - 2019</h3>
          </div>
          <p class="textblock">
            Mezzanine is a spatial computing and collaboration system. My role
            combined sales, design, and engineering in projects with clients
            including IBM and BlackRock. I started as a Sales Engineer, and was
            promoted to Sales Engineering Manager, and then Lead Solutions
            Architect.
          </p>
          <Arrow direction="left" @scroll="slide('eplus')" />
          <Arrow direction="right" @scroll="slide('berkshiregrey')" />
        </div>
      </div>
      <div class="slide" id="berkshiregrey">
        <img class="bigimage" src="../assets/bg-arm.jpg" />
        <div class="card">
          <div class="logoholder">
            <img class="logo" src="../assets/bg-logo.jpg" />
            <h2 class="company">Berkshire Grey</h2>
            <h2 class="jobtitle">
              Senior Software Engineer <br />
              UI/UX Team
            </h2>
            <h3 class="years">2021</h3>
          </div>
          <p class="textblock">
            Berkshire Grey is a pioneer in transformative, AI-enabled robotic
            solutions to automate online order fulfillment and store
            replenishment operations for leading retail, 3PL, grocery, and
            eCommerce companies.
          </p>
          <Arrow direction="left" @scroll="slide('oblong')" />
          <Arrow direction="right" @scroll="slide('deeplocal')" />
        </div>
      </div>
      <div class="slide" id="deeplocal">
        <img class="bigimage" src="../assets/dl-flowers.png" />
        <div class="card">
          <div class="logoholder">
            <img class="logo" src="../assets/dl-logo.png" />
            <h2 class="company">Deeplocal</h2>
            <h2 class="jobtitle">
              Technical Director <br />
              Permanent Exhibits
            </h2>
            <h3 class="years">2021 - Present</h3>
          </div>
          <p class="textblock">
            Deeplocal is an award-winning creative technology and experience
            design company based in Pittsburgh, PA. We invent interactive
            experiences that help brands tell their stories and connect with
            audiences in new and unexpected ways.
          </p>
          <Arrow direction="left" @scroll="slide('berkshiregrey')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from "./Arrow";
export default {
  name: "Slider",
  components: {
    Arrow,
  },
  data: function () {
    return {
      slides: ["A", "B", "C", "D"],
    };
  },
  methods: {
    slide: function (anchorname) {
      document
        .getElementById(anchorname)
        .scrollIntoView({ behavior: "smooth" });
    },
    gotoRight: function () {
      const careerslider = document.getElementById("careerslider");
      careerslider.scrollLeft = careerslider.scrollWidth;
    },
  },
  mounted: function () {
    this.$nextTick(this.gotoRight());
    window.addEventListener("resize", this.gotoRight);
  },
  destroyed: function () {
    window.removeEventListener("resize", this.gotoRight);
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  background-color: black;
}
.title {
  height: 10%;
  padding-top: 0px;
  padding-bottom: 0px;
}

.slideholder {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  scroll-snap-type: x proximity;
  scroll-behavior: smooth;
  height: 90%;
  position: relative;
}
.slide {
  scroll-snap-align: center;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template: "main";
  align-items: center;
  justify-items: center;
}
.bigimage {
  grid-area: main;
  width: 100%;
  height: 100%;
  min-height: 50%;
  max-height: 100vmin;
  object-fit: cover;
  object-position: center top;
}

.arrowoverride {
  height: 8%;
}

#ppi > .bigimage {
  object-position: 60% 60%;
}
#oblong > .bigimage {
  object-position: 0% 60%;
}
#cei > .bigimage {
  object-position: 70% 70%;
}
#eplus > .bigimage {
  object-position: 35% 70%;
}

.logoholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 0vw;
  height: 60%;
  overflow: hidden;
}

.logo {
  width: 15vh;
  border-radius: 5%;
  margin-top: 5vmin;
}
.company {
  font-size: 3.5vh;
  font-weight: 500;
  margin-block-start: 2vh;
  margin-block-end: 1vh;
}
.jobtitle {
  font-size: 3vh;
  font-weight: 500;
  margin-block-start: 1vh;
  margin-block-end: 1vh;
}
.years {
  font-size: 2.5vh;
  font-weight: 500;
  margin-block-start: 1vh;
  margin-block-end: 1vh;
}

.card {
  position: relative;
  grid-area: main;
  width: 65vh;
  height: 75vh;
  background-color: #000000d0;
}

.textblock {
  margin: auto;
  max-width: 75%;
  margin-block-start: 2vh;
  margin-block-end: 1vh;
}

@media only screen and (orientation: portrait) {
  .bigimage {
    grid-area: main;
    width: 100%;
    height: 50%;
    object-fit: cover;
    object-position: center middle;
  }
  .card {
    grid-area: main;
    margin-left: 0%;
    margin-top: 0%;
    width: 100%;
    height: 100%;
    border-radius: 0vh;
    background-color: #00000080;
  }
  .logoholder {
    height: 50%;
    overflow: hidden;
  }
  .slide {
    align-items: start;
  }
}
</style>
